import { InputStepper as CssModulesInputStepper, type InputStepperProps } from '@sunwebgroup/uds-ui/input-stepper'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/input-stepper' instead.
 */
export default Object.assign(
  styled(CssModulesInputStepper)<InputStepperProps>``,
  { displayName: 'InputStepper' },
)
